import { LoginModalContainer } from './containers/LoginModalContainer'

export { LoginModalContainer }



// WEBPACK FOOTER //
// ./client/Modules/PremiumPage/index.js